export const EXPANDED_WIDTH = 224; // w-56
export const COLLAPSED_WIDTH = 68;
